import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as practice from "./style.module.scss";
export const Practice = () => {
  return (
    <section className={`${practice.practice} ${main.sec}`}>
      <div className="container">

        <div className={`${main.blockTitle} ${main.blockTitleMdM} ${practice.practice_title}`}>
          Переводим постановку цели в&nbsp;навык
        </div>

        <div className={practice.practice_subtitle}>
          Вы пройдете:
        </div>

        <div className={`row ${practice.practice_row}`}>
          <div className={`col col-4 ${practice.practice_col}`}>
            <div className={practice.practice_colItem}>
              <div className={practice.practice_colItemIcon}>
                <img src="https://fs.advance.ru/landing-pages/online/smart/02-checklist.svg" alt=""/>
              </div>
              <div className={practice.practice_colItemName}>8 контрольных тестов</div>
              <div>для проверки знаний</div>
            </div>
          </div>

          <div className={`col col-4 ${practice.practice_col}`}>
            <div className={practice.practice_colItem}>
              <div className={practice.practice_colItemIcon}>
                <img src="https://fs.advance.ru/landing-pages/online/smart/02-exam.svg" alt=""/>
              </div>
              <div className={practice.practice_colItemName}>Более 30 упражнений</div>
              <div>на отработку навыка</div>
            </div>
          </div>

          <div className={`col col-4 ${practice.practice_col}`}>
            <div className={practice.practice_colItem}>
              <div className={practice.practice_colItemIcon}>
                <img src="https://fs.advance.ru/landing-pages/online/smart/02-file.svg" alt=""/>
              </div>
              <div className={practice.practice_colItemName}>3 практические работы</div>
              <div>для оценки своих личных и профессиональных целей</div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
